import React, { Component } from 'react';
import { Row, Col, Form } from 'antd';
import {
  forIn,
  sumBy,
  round,
  reduce,
  forEach,
  map,
  clone,
  groupBy,
  isNumber,
  pullAt,
  filter,
  max
} from 'lodash';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BigInputNumber } from 'components/Styled';
import BoxInputRow from './BoxInputRow';
import BoxSelectionRow from './BoxSelectionRow';
import ImageEnvelope from 'assets/images/envelope.svg';
import ImageSmallBox from 'assets/images/small-box.svg';
import ImageLargeBox from 'assets/images/large-box.svg';
import ImageLuggage from 'assets/images/luggage.svg';
import boxes from 'data/boxes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CustomBoxDrawer from './CustomBoxDrawer';
import { getQuotationRequest } from 'ducks/shipments';
import { connect } from 'react-redux';
import helpers from 'utils/helpers';

const getVolumeWeight = box => {
  return (box.length * box.width * box.height) / 5000;
};

const boxImages = {
  envelope: ImageEnvelope,
  smallBox: ImageSmallBox,
  largeBox: ImageLargeBox,
  luggage: ImageLuggage
};

const boxImageStyles = {
  envelope: {
    width: '31px',
    marginRight: '0.8px'
  },
  smallBox: {
    width: '40.6px',
    marginRight: '2.4px'
  },
  largeBox: {
    width: '46.5px',
    marginRight: '9.1px'
  },
  luggage: {
    width: '39px',
    marginRight: '6.3px'
  }
};

class ParcelForm extends Component {
  state = {
    boxList: [],
    totalWeight: 0,
    totalVolumeWeight: 0,
    drawerData: { boxSize: {} },
    drawerVisible: false,
    drawerKey: false // set key to reset default value
  };

  updateBoxData = () => {
    const { boxList, totalWeight, totalVolumeWeight } = this.state;

    this.props.updateBoxData({
      boxes: filter(boxList, b => {
        return b.quantity;
      }),
      totalWeight: round(totalWeight, 1),
      totalVolumeWeight: round(totalVolumeWeight, 1),
      previewWeight: round(max([totalWeight, totalVolumeWeight]), 1),
      totalBox: reduce(
        this.state.boxList,
        (r, k) => {
          return r + k.quantity;
        },
        0
      )
    });
  };

  handleTotalWeightChange = value => {
    value = round(value, 1);

    this.setState(
      {
        totalWeight: value,
        totalWeightStatus: value === 0 ? 'error' : ''
      },
      this.updateBoxData
    );
  };

  validateTotalWeight = () => {
    this.setState({
      totalWeightStatus: this.state.totalWeight === 0 ? 'error' : ''
    });
  };

  handleEditedWeight = () => {
    window.dataLayer.push({
      event: 'Edit Weight',
      ecommerce: undefined,
      editedWeight: this.state.totalWeight
    });
  };

  calculateVolumeWeight = boxList => {
    let totalVolumeWeight = 0;
    forEach(boxList, b => {
      totalVolumeWeight += getVolumeWeight(b) * b.quantity;
    });

    return totalVolumeWeight;
  };

  mergeBoxList = boxList => {
    const a = [];
    let tmp = groupBy(
      boxList,
      x => `${x.boxType}-${x.length}-${x.width}-${x.height}`
    );
    forIn(tmp, (v, k) => {
      if (v.length === 1) {
        a.push(v[0]);
      } else {
        const o = v[0];
        o.quantity = sumBy(v, 'quantity');
        a.push(o);
      }
    });

    return a;
  };

  handleAddBox = ({ boxType, boxSize }) => {
    let boxList = clone(this.state.boxList);
    boxList.push({
      boxType,
      ...boxSize,
      quantity: 1
    });

    boxList = this.mergeBoxList(boxList);

    this.updateBoxes(boxList);
  };

  handleUpdateBox = ({ boxType, boxSize, index }) => {
    let boxList = clone(this.state.boxList);

    const element = boxList[index];
    element.boxType = boxType;
    element.length = boxSize.length;
    element.width = boxSize.width;
    element.height = boxSize.height;

    boxList = this.mergeBoxList(boxList);

    this.updateBoxes(boxList);
  };

  handleRemoveBox = ({ index }) => {
    let boxList = clone(this.state.boxList);
    pullAt(boxList, index);

    this.updateBoxes(boxList);
  };

  handleBoxChange = (value, i) => {
    let boxList = clone(this.state.boxList);
    boxList[i].quantity = value;

    this.updateBoxes(boxList);
  };

  updateBoxes = boxList => {
    const totalVolumeWeight = this.calculateVolumeWeight(boxList);
    this.setState(
      {
        boxList,
        totalVolumeWeight
      },
      this.updateBoxData
    );
  };

  handleDrawerOpen = ({ boxType, boxSize, index }) => {
    this.setState({
      drawerVisible: true,
      drawerKey: !this.state.drawerKey,
      drawerData: { boxType, boxSize, index }
    });
  };

  handleDrawerClose = () => {
    this.setState({
      drawerVisible: false
    });
  };

  handleDrawerSubmit = ({ boxType, boxSize, index }) => {
    if (isNumber(index)) {
      this.handleUpdateBox({ boxType, boxSize, index });
    } else {
      this.handleAddBox({ boxType, boxSize });
    }

    this.handleDrawerClose();
  };

  handleKeyDown = e => {
    const unit = ' KG';
    if (e.target.selectionStart > e.target.value.length - unit.length) {
      e.target.setSelectionRange(
        e.target.value.length - unit.length,
        e.target.value.length - unit.length
      );
    }
    if (e.keyCode === 13) {
      const { totalBox, totalWeight } = this.props.boxData;

      if (!totalBox || !totalWeight) {
        helpers.message.error(
          this.props.t('quotation.err_msg.empty_quantity_weight'),
          'quotation'
        );
        this.props.validateTotalWeight();
        return;
      }

      if (!this.props.origin || !this.props.destination) {
        helpers.message.error(
          this.props.t('quotation.err_msg.empty_countries'),
          'quotation'
        );
        this.props.validateCountries();
        return;
      }

      this.props.getQuotationRequest({
        origin: this.props.origin,
        destination: this.props.destination,
        boxData: this.props.boxData
      });
    }
  };

  handleClick = e => {
    const unit = ' KG';
    e.target.setSelectionRange(
      e.target.value.length - unit.length,
      e.target.value.length - unit.length
    );
  };

  initBoxData = boxData => {
    this.setState({
      totalWeight: boxData.totalWeight,
      totalVolumeWeight: boxData.totalVolumeWeight,
      boxList: map(boxData.boxes, x => {
        let boxType = 'largeBox';
        if (x.height === 1) {
          boxType = 'envelope';
        } else if (
          x.height <= 5 &&
          (x.length * x.width * x.height) / 5000 <= 2
        ) {
          boxType = 'smallBox';
        }

        return {
          ...x,
          boxType
        };
      })
    });
  };

  renderBadge = () => {
    return (
      <span
        className="buttonSecond-background"
        style={{
          backgroundColor: '#9900A5',
          padding: '3px 10px',
          borderRadius: '5px',
          fontSize: '10px',
          fontWeight: 700,
          color: '#f5f5f5'
        }}>
        {this.props.t('quotation.weight_for_calculation')}
      </span>
    );
  };

  render() {
    const useVolumeWeight =
      this.state.totalVolumeWeight &&
      this.state.totalWeight &&
      this.state.totalVolumeWeight > this.state.totalWeight;
    const useActualWeight =
      this.state.totalVolumeWeight &&
      this.state.totalWeight &&
      this.state.totalVolumeWeight <= this.state.totalWeight;

    return (
      <React.Fragment>
        <div
          style={{
            padding: '10px 0'
          }}>
          {map(this.state.boxList, (x, i) => {
            const { length, width, height, quantity, boxType } = x;

            return (
              <BoxInputRow
                key={`${boxType}-${length}-${width}-${height}`}
                t={this.props.t}
                boxImage={boxImages[boxType]}
                boxImageStyle={boxImageStyles[boxType]}
                boxType={boxType}
                boxSize={{ length, width, height }}
                boxQuantity={quantity}
                handleBoxChange={value => {
                  this.handleBoxChange(value, i);
                }}
                handleDrawerOpen={({ boxType, boxSize }) => {
                  this.handleDrawerOpen({ boxType, boxSize, index: i });
                }}
                handleRemoveBox={() => {
                  this.handleRemoveBox({ index: i });
                }}
              />
            );
          })}
          {map(boxes, (v, k) => {
            return (
              <BoxSelectionRow
                key={k}
                t={this.props.t}
                boxImage={boxImages[k]}
                boxImageStyle={boxImageStyles[k]}
                boxType={k}
                boxSize={boxes[k]}
                handleDrawerOpen={this.handleDrawerOpen}
                handleDrawerSubmit={this.handleDrawerSubmit}
                openStaticPopup={this.props.openStaticPopup}
                getVolumeWeightPopup={this.props.getVolumeWeightPopup}
              />
            );
          })}
        </div>
        <CustomBoxDrawer
          key={this.state.drawerKey}
          t={this.props.t}
          boxImage={boxImages[this.state.drawerData.boxType]}
          boxImageStyle={boxImageStyles[this.state.drawerData.boxType]}
          boxType={this.state.drawerData.boxType}
          boxSize={this.state.drawerData.boxSize}
          index={this.state.drawerData.index}
          visible={this.state.drawerVisible}
          onClose={this.handleDrawerClose}
          onSubmit={this.handleDrawerSubmit}
          openStaticPopup={this.props.openStaticPopup}
          getVolumeWeightPopup={this.props.getVolumeWeightPopup}
        />
        <div style={{ margin: '0 -15px' }}>
          <div
            style={{
              backgroundColor: '#fafafa',
              padding: '10px',
              fontSize: '12px',
              textAlign: 'center'
            }}>
            {`${this.props.t('quotation.parcel_form.total')} `}
            <span
              className="buttonSecond-color"
              style={{ color: '#9900A5', fontWeight: 700, fontSize: '18px' }}>
              {reduce(
                this.state.boxList,
                (r, k) => {
                  return r + k.quantity;
                },
                0
              )}
            </span>
            {` ${this.props.t('quotation.parcel_form.box')}`}
          </div>
          <Row align="middle" style={{ padding: '25px 0 10px' }}>
            <Col
              span={12}
              style={{ textAlign: 'center', borderRight: '1px solid #d9dfec' }}>
              <div style={{ paddingBottom: '8px' }}>
                {this.props.t('quotation.total_volume_weight')}
              </div>
              <div
                className={useVolumeWeight ? 'buttonSecond-color' : ''}
                style={{
                  fontSize: '24px',
                  fontWeight: 700,
                  lineHeight: '50px',
                  color: useVolumeWeight ? '#9900A5' : undefined
                }}>
                {this.state.totalVolumeWeight.toFixed(1)} KG
              </div>
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              <div style={{ paddingBottom: '8px' }}>
                {this.props.t('quotation.total_weight')}
              </div>
              <Form.Item
                style={{
                  marginBottom: 0,
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}
                validateStatus={this.state.totalWeightStatus || ''}>
                <BigInputNumber
                  min={0}
                  max={9999}
                  value={this.state.totalWeight || null}
                  onChange={this.handleTotalWeightChange}
                  onBlur={this.handleEditedWeight}
                  onClick={this.handleClick}
                  formatter={value =>
                    `${value.toString().replace(/[^\d.]/g, '')} KG`
                  }
                  parser={value =>
                    value.toString().replace('KG', '').replace(' ', '')
                  }
                  onKeyDown={this.handleKeyDown}
                  precision={1}
                  inputMode="decimal"
                  placeholder="0"
                  className={useActualWeight ? 'buttonSecond-color' : ''}
                  style={{
                    fontSize: '24px',
                    width: '130px',
                    color: useActualWeight ? '#9900A5' : undefined
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12} style={{ textAlign: 'center' }}>
              {useVolumeWeight ? this.renderBadge() : null}
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              {useActualWeight ? this.renderBadge() : null}
            </Col>
          </Row>
          <div
            style={{
              color: '#2C2C2E',
              fontSize: '12px',
              padding: '20px 15px 5px',
              textAlign: 'center'
            }}>
            <span
              dangerouslySetInnerHTML={{
                __html: this.props.t('quotation.remarks')
              }}
            />
            <span
              className="buttonSecond-color"
              style={{
                color: '#57D7DD',
                paddingLeft: '3px',
                cursor: 'pointer'
              }}
              onClick={() => {
                this.props.openStaticPopup(this.props.getVolumeWeightPopup());
              }}>
              <FontAwesomeIcon icon="question-circle" />
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.shipments.loading
  };
};

const mapDispatchToProps = {
  getQuotationRequest
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(ParcelForm);
